import "./AboutAd.scss";

import { FC, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { aboutADDisplayedEvent, productOfferEditEvent } from "analytics/productOfferEvents";
import HeroImage from "assets/images/illustrations/AboutADHero/AboutADHero.svg";
import ADFAQ from "components/ADFAQ/ADFAQ";
import ADOfferCard from "components/ADOfferCard/ADOfferCard";
import { DynamicFormItems, IDynamicForm } from "config/types/dynamicForm.types";
import { VerticalLayout } from "containers/DynamicForm/DynamicFormLayouts/VerticalLayout";
import { Layout, useJourney, useTranslation } from "modules";
import { useAppDispatch } from "store";
import { getWyshADOffering } from "store/selectors";
import { filterPrimaryButtons } from "utils/form";
import { scrollToTop } from "utils/scrollToTop";

import Features from "./Features";

interface IProps {
  dynamicFormItems?: DynamicFormItems[];
  groups?: IDynamicForm["groups"];
  onClickEdit?(offeringType: "termLifeOffering" | "adOffering"): void;
  onClickBack?(): void;
}

const AboutAD: FC<IProps> = props => {
  const { dynamicFormItems, groups, onClickEdit } = props;
  const { t } = useTranslation();
  const adOffering = useSelector(getWyshADOffering);
  const { anyJourneysActive } = useJourney();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const hasValidADProduct = adOffering && adOffering?.status !== "expired";

  const content = {
    pretitle: t("ad.about.pretitle", "INTRODUCING"),
    title: t("ad.about.title", "Accidental death insurance"),
    subtitle: t(
      "ad.about.subtitle",
      "Unlike term life insurance, that covers most cases of death, accidental death insurance is focused only on accident-related deaths. See below for more details."
    ),
    heroImage: HeroImage,
    twoOfferings: hasValidADProduct,
  };

  const handleEditClick = () => {
    if (onClickEdit) {
      onClickEdit("adOffering");
    } else {
      navigate("/edit-coverage/adOffering");
    }
    dispatch(productOfferEditEvent("ad"));
  };

  useEffect(() => {
    dispatch(aboutADDisplayedEvent());
    scrollToTop({ behavior: "auto" });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <Layout
        className="about-ad"
        as="ADProductOfferingLayout"
        content={content}
        backNav={{
          hasBackNav: false,
          replaceExitInJourneyWithBack: anyJourneysActive,
        }}>
        <Features />
        <VerticalLayout groups={groups} items={filterPrimaryButtons(dynamicFormItems)} />
        {adOffering && adOffering.status !== "expired" && (
          <ADOfferCard
            mode="purchase"
            productOffering={adOffering}
            onClickEdit={handleEditClick}
            dynamicFormItems={dynamicFormItems}
          />
        )}
      </Layout>
      <div className="result-ad__faq">
        <ADFAQ />
      </div>
    </>
  );
};

export default AboutAD;
